import { render, staticRenderFns } from "./bindMenu.vue?vue&type=template&id=46691343&scoped=true"
import script from "./bindMenu.vue?vue&type=script&lang=js"
export * from "./bindMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46691343",
  null
  
)

export default component.exports